import React from 'react';
import ClientesFiscalesManager from '../components/facturacion/ClientesFiscalesManager';

const ClientesFiscales: React.FC = () => {
  return <ClientesFiscalesManager />;
};

export default ClientesFiscales;
